import { useContext } from 'react';
import {
  determineEntryTypeFromOrigin,
  PROXY_ACCESS_ENTRY,
} from '@vp/common-dev-tooling';
import SiteContext from '../components/contexts/SiteContext';
import {
  ORDER_DETAILS_SOURCE_PAGE,
  ORDER_HISTORY_SOURCE_PAGE,
} from '../constants/orderdetailsui';

const useSiteData = () => {
  const siteData = useContext(SiteContext);
  const {
    siteName,
    siteBaseUrl,
    allowAnonymousShoppers,
    uiLocalization = {},
    geoData = {},
    nav = {},
    uiData = {},
    featureControls,
    vistacartTenantName: vistacartTenant,
    tenantEnvironment,
    auth = {},
    tracking = {},
  } = siteData;

  const entryType = determineEntryTypeFromOrigin();
  const { locale } = uiLocalization;

  const navDefaults = {
    base: `../`,
    orderHistory: `/oh/`,
    cart: `/c/`,
    orderDetails: `/od/`,
    checkout: `/co/`,
  };
  let navOverrides = {};

  if (entryType !== PROXY_ACCESS_ENTRY) {
    navOverrides = {
      orderHistory: '../orderhistory/',
      cart: `https://cartui.cdn.orders.vpsvc.com/${siteName}/${locale}/cart`,
      orderDetails: '../orderdetails/',
      checkout: `https://checkoutui.cdn.orders.vpsvc.com/${siteName}/${locale}/checkout`,
    };
  }

  const reorderEnabled = {
    orderDetails: uiData?.orderDetails?.reorderEnabled || false,
    orderHistory: uiData?.orderHistory?.reorderEnabled || false,
  };

  const allowAnonymousSessions = auth?.allowAnonymous || false;
  const customerEditShippingAddressEnabled =
    uiData?.orderDetails?.customerShippingAddressEditEnabled || false;
  const postOrderStudioEnabled =
    uiData?.orderDetails?.postOrderStudioEnabled || false;
  const printerFriendlyEnabled =
    uiData?.orderDetails?.printerFriendlyEnabled || false;
  const selfOrderTransferEnabled =
    uiData?.orderDetails?.selfOrderTransferEnabled || false;

  const shippingAddressAutocompleteEnabled =
    uiData?.checkout?.addressAutocomplete?.shippingAddressEnabled || false;
  const loqateAPIKey = uiData?.addressValidation?.loqateAPIKey || null;
  const countriesWithLoqateEnabled =
    uiData?.addressValidation?.loqateEnabledCountries || [];
  const shippingAddressValidationEnabled =
    uiData?.checkout?.addressValidation?.shippingAddressEnabled || false;
  const addressAutocompleteConfig = uiData?.addressAutocomplete || {
    provider: 'NONE',
  };
  const authSites = {
    [ORDER_DETAILS_SOURCE_PAGE]: uiData?.orderDetails?.auth?.site || null,
    [ORDER_HISTORY_SOURCE_PAGE]: uiData?.orderHistory?.auth?.site || null,
  };

  // build URL for Embroidery Guidelines; see OMNI: https://gitlab.com/vistaprint-org/order-management/straw-hat-pirates/omni/-/blob/master/src/main/java/com/vistaprint/omni2/data/email/CustomerNotificationEmail.java?ref_type=heads#L107
  const embroideryUrl = `${nav.helpCenter}14808582054925/`;

  return {
    uiData,
    uiLocalization,
    siteName,
    siteBaseUrl,
    locale,
    geoData,
    externalAppNavigation: { ...navDefaults, ...nav, ...navOverrides },
    vistacartTenant,
    featureControls,
    tenantEnvironment,
    allowAnonymousSessions,
    allowAnonymousShoppers,
    reorderEnabled,
    selfOrderTransferEnabled,
    postOrderStudioEnabled,
    printerFriendlyEnabled,
    customerEditShippingAddressEnabled,
    loqateAPIKey,
    countriesWithLoqateEnabled,
    shippingAddressValidationEnabled,
    shippingAddressAutocompleteEnabled,
    addressAutocompleteConfig,
    authSites,
    tracking,
    embroideryUrl,
  };
};

export default useSiteData;
